var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPurchaseGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Purchase_Gift_icon_64x64",
    "data-name": "Purchase Gift icon 64x64",
    transform: "translate(-327 -361)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_64x64",
    "data-name": "64x64",
    width: 64,
    height: 64,
    transform: "translate(327 361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "gift_icon",
    "data-name": "gift icon",
    transform: "translate(339 373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M36,12V32H4V12",
    transform: "translate(0 8)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M2,7H42V17H2Z",
    transform: "translate(-2 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M12,37V7",
    transform: "translate(8 3)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M19,12H10A5,5,0,0,1,10,2C17,2,19,12,19,12Z",
    transform: "translate(1 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M12,12h9A5,5,0,0,0,21,2C14,2,12,12,12,12Z",
    transform: "translate(8 -2)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "money_icon",
    "data-name": "money icon"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(363 397)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": "$",
    transform: "translate(363.68 398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M11.7,10.022C9.473,9.5,8.756,8.956,8.756,8.111c0-.969.992-1.644,2.652-1.644,1.749,0,2.4.756,2.456,1.867h2.171a3.655,3.655,0,0,0-3.153-3.387V3H9.935V4.92C8.029,5.293,6.5,6.413,6.5,8.129c0,2.053,1.876,3.076,4.617,3.671,2.456.533,2.947,1.316,2.947,2.142,0,.613-.481,1.591-2.652,1.591-2.024,0-2.819-.818-2.927-1.867H6.32c.118,1.947,1.729,3.04,3.615,3.4V19h2.947V17.089c1.916-.329,3.438-1.333,3.438-3.156C16.32,11.409,13.933,10.547,11.7,10.022Z",
    fill: "#fff"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseGiftIcon);
export default __webpack_public_path__ + "static/media/PurchaseGiftIcon.f944a5dfef7e79b5e5d55a59290ed656.svg";
export { ForwardRef as ReactComponent };